import React from 'react';
import { StyleProp, StyleSheet, Text, TouchableOpacity, ViewStyle } from 'react-native';
import Theme from '../../theme';

interface IProps {
  style?: StyleProp<ViewStyle>;
  t(key: string): string;
  login(): void;
}

export const AlreadyHaveAnAccount = ({ t, login, style }: IProps) => (
  <TouchableOpacity onPress={login} style={[styles.container, style]}>
    <Text style={styles.textHighlight}>{t('alreadyHaveAccount')}</Text>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  container: {
    paddingVertical: 7,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  textHighlight: {
    fontSize: 16,
    color: Theme.PRIMARY,
    fontFamily: Theme.Custom800,
  },
});
